const theme_light = {
  id: 2,
  name: "light",
  displayName: "Light",
  themeBaseType: "light",
  themeVariables: {
    COLORS: {
      ACCENT: "#0099cc",
      SECONDARY: "#9CAFBF",
      SURFACE: "#F2F2F2",
      SURFACE_LIGHTER: "#E6E6E6",
      RECEIVE_BUBBLE: "#DDDDDD",
      BACKGROUND: "#F2F2F2",
      APP_BACKGROUND: "#E6E6E6",
      ON_ACCENT: "#FFFFFF",
      ON_SURFACE: "#121212",
      ON_BACKGROUND: "#121212",
    },
    BUTTON: {
      BORDER_RADIUS: "25px",
      SHADOW: "0 0 16px 0px rgba(0, 0, 0, 0.3)",
    },
    CONTAINER: {
      BORDER_RADIUS: "12px",
      SHADOW: "0px 0px 13px 1px rgba(0, 0, 0, 0.1)",
    },
    LIST: {
      BORDER_RADIUS: "15px",
    },
  },
};

export default theme_light;
